export const PUT_DISABLE_WHITELIST = 'PUT_DISABLE_WHITELIST';
export const PUT_DISABLE_WHITELIST_SUCCESS = 'PUT_DISABLE_WHITELIST_SUCCESS';
export const PUT_DISABLE_WHITELIST_ERROR = 'PUT_DISABLE_WHITELIST_ERROR';

// ----------------------
// Tipos
// ----------------------

export interface GenericState<T> {
  loading: boolean;
  data: T | null;
  error: string | null;
}

export interface Action<T = any> {
  type: string;
  payload?: T;
}

// ----------------------
// Estado inicial
// ----------------------

export const initialStateModifyWhiteList: GenericState<any> = {
  loading: false,
  data: null,
  error: null,
};

export const putModifyWhiteListRed = (
  state = initialStateModifyWhiteList,
  action: Action
): GenericState<any> => {
  switch (action.type) {
    case PUT_DISABLE_WHITELIST:
      return { ...state, loading: true, error: null };
    case PUT_DISABLE_WHITELIST_SUCCESS:
      return { ...state, loading: false, data: action.payload ?? null };
    case PUT_DISABLE_WHITELIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload ?? 'Error al deshabilitar la WhiteList',
      };
    default:
      return state;
  }
};
